import { render, staticRenderFns } from "./VideoCourses.vue?vue&type=template&id=1cf7c1cd&scoped=true&"
import script from "./VideoCourses.vue?vue&type=script&lang=js&"
export * from "./VideoCourses.vue?vue&type=script&lang=js&"
import style0 from "./VideoCourses.vue?vue&type=style&index=0&id=1cf7c1cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf7c1cd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VFlex,VIcon,VSpacer})
